import $ from '@rover/globals/jquery';
import Backbone from '@rover/globals/backbone';
import Mustache from '@rover/globals/Mustache';
import _ from '@rover/globals/underscore';

export default Backbone.View.extend({
  template: Mustache.template('new_design/account_conversations/requester_add_on'),
  events: {
    'change .js-requester-add-on-selection': 'toggleActive',
  },
  initialize(options) {
    _.bindAll(this, 'toggleActive', 'toggleDisabled', 'isValid', 'render');
    this.addOn = options.addOn;
    this.requestableModel = options.requestableModel;
    this.requestableModel.on('changing:requester_add_ons', this.toggleDisabled);
    this.$form = this.$('js-requester-add-on-form');
    this.$navbar = $('.js-header-navbar');
  },
  toggleDisabled(slug, value) {
    this.$('input').attr('disabled', value);
  },
  toggleActive() {
    this.toggleDisabled(this.addOn.slug, true);
    this.requestableModel.toggleRequesterAddOn(
      this.addOn.slug,
      this.$('.js-requester-add-on-selection:checked').val() === 'true'
    );
  },
  isValid() {
    if (!this.$form.length) {
      return true;
    }

    if (this.$form.length && this.$form.valid()) {
      return true;
    }

    if (this.$el.offset().top < $(window).scrollTop() - this.$navbar.height() - 30) {
      $('html,body').animate(
        {
          scrollTop: this.$el.offset().top - this.$navbar.height() - 30,
        },
        'fast'
      );
      return false;
    }

    return false;
  },
  render() {
    this.$el.html(this.template.render(this.addOn));
    this.$('[data-toggle="popover"]').popover();
    this.$form.validate();
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/checkout/optional_requester_addon_view.js